import { memo } from "react";
import usePropertyHelpTypeLocations from "@rf/property/module/components/property-form/hooks/helps/usePropertyHelpTypeLocations";
import BusinessDataFormSectionForProject from "./BusinessDataFormSectionForProject";
import BusinessDataFormSectionForNormalProperty from "./BusinessDataFormSectionForNormalProperty";

const BusinessDataFormSection = () => {
  const { isProject } = usePropertyHelpTypeLocations();

  return isProject ? (
    <BusinessDataFormSectionForProject />
  ) : (
    <BusinessDataFormSectionForNormalProperty />
  );
};

export default memo(BusinessDataFormSection);
